import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/incidents';

export default function FeaturedStories() {
  const list = articles.slice(0, 6);

  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionTitle
            label="案件追踪"
            title="正在追踪的重点条目"
            desc="覆盖案件审理、抓捕行动、解救进展与警示科普，每条都保留来源与时间标注。"
          />
          <Link
            to="/cases"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部条目
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}